import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import FieldType from 'app/admin/dataset/dto/FieldType';

import EdtDynamicCheckLogService from 'app/admin/edtDynamicCheckLog/service/EdtDynamicCheckLogService';
import EdtDynamicCheckEditService from '../service/EdtDynamicCheckEditService';

const config = data => {
	return {
		key: 'edtDynamicCheckEditForm',
		topic: 'edtDynamicCheck',
		service: EdtDynamicCheckEditService,
		tabList: initData => {
			return [
				{ key: 'basic' },
				{ key: 'disturbanceVariables' },
				{ key: 'setPoints' },
				{ key: 'sequenceFinishedTags' },
				{ key: 'variablesToMonitor' },
				{ key: 'alarmVariables' },
			];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'hostName',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'serverName',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'modelName',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'log',
					component: EditFormSelectField,
					items: () => EdtDynamicCheckLogService.getListSelection()
				},
				{
					key: 'sequenceStartItemId',
					component: EditFormTextField
				},
				{
					key: 'readInterval',
					component: EditFormTextField,
					type: 'number'
				},
				{
					key: 'timeWindow',
					component: EditFormTextField,
					type: 'number'
				},
				{
					key: 'maxIterations',
					component: EditFormTextField,
					required: true,
					type: 'number',
				},
				{
					key: 'minSampleCountForVarianceCheck',
					component: EditFormTextField,
					required: true,
					type: 'number',
				},
				{
					key: 'disturbanceVariables',
					tab: 'disturbanceVariables',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						itemId: null,
						value: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'itemId',
							component: EditFormTextField,
							required: true,
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							type: 'number'
						}
					]
				},
				{
					key: 'setPoints',
					tab: 'setPoints',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						itemId: null,
						value: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'itemId',
							component: EditFormTextField,
							required: true,
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							type: 'number'
						}
					]
				},
				{
					key: 'sequenceFinishedTags',
					tab: 'sequenceFinishedTags',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						itemId: null,
						value: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'itemId',
							component: EditFormTextField,
							required: true,
						}
					]
				},
				{
					key: 'variablesToMonitor',
					tab: 'variablesToMonitor',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						itemId: null,
						value: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'itemId',
							component: EditFormTextField,
							required: true,
						},
						{
							key: 'sigma',
							component: EditFormTextField,
							required: true,
							type: 'number'
						}
					]
				},
				{
					key: 'alarmVariables',
					tab: 'alarmVariables',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						itemId: null,
						value: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'itemId',
							component: EditFormTextField,
							required: true,
						}
					]
				}
			];

			return fields;
		}
	};
};

function EdtDynamicCheckEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(EdtDynamicCheckEditForm);